export const phoneFormat = '+7 981 142 68 42';
export const phone = phoneFormat.split(' ').join('');
export const phoneLink = `tel:${phone}`;

export const email = 'hi@ptburg.com';
export const emailLink = `mailto:${email}`;

export const telegramUserName = 'Ivan_Novoselov';
export const telegramLink = `https://t.me/${telegramUserName}`;
